module.exports = __webpack_public_path__ + "img/square-ellipsis.9634536f.svg";